import { render, staticRenderFns } from "./shiftDetail.vue?vue&type=template&id=69b4feb6&scoped=true&"
import script from "./shiftDetail.vue?vue&type=script&lang=js&"
export * from "./shiftDetail.vue?vue&type=script&lang=js&"
import style0 from "./shiftDetail.vue?vue&type=style&index=0&id=69b4feb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b4feb6",
  null
  
)

export default component.exports